export default function Footer() {
  const footerLinks = [
    { label: '剧集分类', href: '#index' },
    { label: '今日精选', href: '#cards' },
    { label: '热度榜单', href: '#ranking' },
    { label: '热门话题', href: '#topics' },
    { label: '平台特色', href: '#features' },
    { label: '常见问题', href: '#faq' },
    { label: '投稿合作', href: '#contact' },
    { label: '关于我们', href: '#about' },
  ];

  return (
    <footer id="footer" className="bg-background-900">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-line text-xl text-primary-400"></i>
              </span>
              <span className="text-lg font-bold font-heading text-background-100 whitespace-nowrap">
                草民影院
              </span>
            </div>
            <p className="text-xs text-background-400/80 leading-relaxed mb-4">
              草民影院汇聚全网热门电视剧全集，国产剧、韩剧、美剧在线观看，高清不卡，即点即看，为追剧爱好者提供最优质的观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4 font-heading">
              快速导航
            </h4>
            <ul className="flex flex-col gap-2">
              {footerLinks.slice(0, 4).map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-xs text-background-400/80 hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4 font-heading">
              更多内容
            </h4>
            <ul className="flex flex-col gap-2">
              {footerLinks.slice(4).map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-xs text-background-400/80 hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4 font-heading">
              合作伙伴
            </h4>
            <p className="text-xs text-background-400/60 leading-relaxed">
              优质内容平台持续入驻中，合作联系 contact@caomin.tv
            </p>
          </div>
        </div>

        <div className="border-t border-background-800/50 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400/60">
            &copy; {new Date().getFullYear()} 草民影院 caomin.tv — 高清不卡，即点即看
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-400/60 hover:text-primary-400 transition-colors">
              回到顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}